export default __webpack_public_path__ + "static/feature-bg-afb825c74c4cd81bc3d032a806f63db6.svg";